import React, { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { FORTNOX_STATUS } from "utils/options/FORTNOX_STATUS";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import LinkIcon from "@mui/icons-material/Link";

export default function FortnoxButton({
  clientName,
  status,
  asyncHandleSendToClient,
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onMainClick = () => {
    if (status === FORTNOX_STATUS.VERIFIED) setOpen(true);
    else asyncHandleSendToClient();
  };

  const confirmCancel = async () => {
    setLoading(true);
    try {
      await asyncHandleSendToClient();
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingButton
        color={status === FORTNOX_STATUS.VERIFIED ? "error" : "primary"}
        variant="contained"
        onClick={onMainClick}
        sx={{ width: "100%", gap: "1rem" }}
        startIcon={
          status === FORTNOX_STATUS.VERIFIED ? <LinkOffIcon /> : <LinkIcon />
        }
      >
        {status === FORTNOX_STATUS.SENT
          ? "Skicka igen"
          : status === FORTNOX_STATUS.VERIFIED
          ? "Avsluta integration"
          : "Skicka till klient"}
      </LoadingButton>

      <Dialog open={open} onClose={() => !loading && setOpen(false)}>
        <DialogTitle>Fortnox - Avsluta Integration</DialogTitle>
        <DialogContent>
          Är du säker på att du vill ta bort integrationen för {clientName}?
          <DialogContentText>Detta går INTE att ångra</DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpen(false)} disabled={loading}>
            Avbryt
          </Button>
          <LoadingButton
            color="error"
            onClick={confirmCancel}
            loading={loading}
            variant="contained"
          >
            Ja
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
